import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface EntityAnalyticsCardProps {
  title: string;
  value: React.ReactNode;
  icon?: React.ReactNode;
  description?: string;
  className?: string;
}

export function EntityAnalyticsCard({
  title,
  value,
  icon,
  description,
  className,
}: EntityAnalyticsCardProps) {
  return (
    <Card className={cn('p-4 py-4 gap-2', className)}>
      <CardContent className="p-0">
        <p className="text-sm text-muted-foreground">{title}</p>
        <div className="flex items-center gap-2">
          {icon && <span className="text-muted-foreground">{icon}</span>}
          <span className="text-2xl font-bold">{value}</span>
        </div>
        {description && (
          <p className="text-xs text-muted-foreground mt-1">{description}</p>
        )}
      </CardContent>
    </Card>
  );
}

interface EntityAnalyticsGridProps {
  children: React.ReactNode;
  className?: string;
}

export function EntityAnalyticsGrid({
  children,
  className,
}: EntityAnalyticsGridProps) {
  return (
    <div className={cn('grid grid-cols-2 lg:grid-cols-4 gap-4', className)}>
      {children}
    </div>
  );
}
